import React, { useEffect, useState } from 'react'
import { ClickAwayListener } from '@material-ui/core'
import InfiniteScroll from 'react-infinite-scroller'

//images
import loader from '../../../assets/images/contacts/loader.svg'
import messageIcon from '../../../assets/images/header/messages.png'
import justStartedIcon from '../../../assets/images/header/success.png'
import startingWithTopicsIcon from '../../../assets/images/header/video.png'
import watchedFirstVideoOfFirstTopicIcon from '../../../assets/images/header/results.png'
import startingWithTestsIcon from '../../../assets/images/header/test.png'
import feedbackIcon from '../../../assets/images/header/feedback.png'
import justActivatedIcon from '../../../assets/images/header/just-activated.png'
import justConfirmedIcon from '../../../assets/images/header/just-confirmed.png'
import activationExpiresIcon from '../../../assets/images/header/activation-expires.png'

//actions
import { getNotifications } from '../../../__actions/notifications'
import { handleNotification } from '../../../__actions/notifications'
import { getNotificationsCount } from '../../../__actions/notifications'
import { notificationMarkAsRead } from '../../../__actions/notifications'

//dispatcher
import { useSelector, useDispatch } from 'react-redux'

function Notifications() {
    const [state, setState] = useState({
        show: false
    })
    const dispatch = useDispatch()
    //
    const __notifications = useSelector(state => state)
    //
    const notifications = __notifications.notificationsReducer
    //
    const globalModals = __notifications.globalModalsReducer

    //notification types
    const justRegistered = 'StudentRegistered'
    const startingWithTopics = 'VideoTutor'
    const watchedFirstVideoOfFirstTopic = 'FirstVideo'
    const startingWithTests = 'TestTutor'
    const feedback = 'WriteReview'
    const justActivated = 'StudentActivated'
    const justConfirmed = 'StudentAccepted'
    const activationExpires = 'StudentActivationExpires'

    useEffect(() => {
        dispatch(getNotifications(1))
        dispatch(getNotificationsCount())
    }, [])

    const toggleNotifications = show => {
        if (document.querySelector('.notifications-nav').getAttribute('data-clicked') == 1) {
            show = true
        }
        setState(prev => ({
            ...prev,
            show
        }))
    }

    useEffect(() => {
        if (!globalModals?.JUST_REGISTERED?.show && notifications?.new?.count > 0 && !notifications?.loading) {
            const data = notifications?.data?.items || []
            data.map(notification => {
                if (notification.type.includes(justRegistered) && !notification.read) {
                    dispatch(handleNotification('justRegistered', notification))
                }
            })
        }
    }, [notifications])

    const calcTime = date => {
        const notificationDate = new Date(date)
        const currentDate = new Date()
        const diffTime = Math.abs(notificationDate - currentDate)

        const minutes = Math.floor(diffTime / 60000)
        let hours = minutes % 60 ? minutes / 60 : 0

        hours = hours < 1 ? 0 : hours.toFixed(0)

        return {
            text: hours ? hours > 5 ? 'отвори съобщението' : `Преди ${hours} ч.` : minutes == 0 ? 'Току-що' : `Преди ${minutes} мин.`
        }
    }

    return (
        <ClickAwayListener onClickAway={() => state.show && toggleNotifications(false)}>
            <li className="notifications-nav" data-clicked="0" onClick={e => {
                toggleNotifications(e.target.getAttribute('data-clicked') == 1 ? e.target.getAttribute('data-clicked') ? !state.show : false : false || e.target.getAttribute('data-clicked') ? !state.show : false)
            }}>
                <img src={messageIcon} title="Съобщения" />
                {notifications?.new?.count > 0 ?
                    <span>
                        {notifications?.new?.count}
                    </span> : ''}
                <div className={`notifications ${state.show ? 'show' : ''}`}>
                    <ul>
                        <InfiniteScroll
                            pageStart={1}
                            loadMore={() => dispatch(getNotifications(notifications.page + 1))}
                            hasMore={notifications?.data?.has_more}
                            loader={<img src={loader} alt="loading" className="loading" />}
                            initialLoad={false}
                            useWindow={false}
                        >
                            <div className="tracks">
                                {notifications?.data?.items.map(notification =>
                                    <li
                                        key={notification.id}
                                        data-id={notification.id}
                                        onClick={() => {
                                            dispatch(handleNotification(notification.type.includes(justRegistered) ? 'justRegistered' :
                                                notification.type.includes(startingWithTopics) ? 'startingWithTopics' :
                                                    notification.type.includes(watchedFirstVideoOfFirstTopic) ? 'watchedFirstVideoOfFirstTopic' :
                                                        notification.type.includes(startingWithTests) ? 'startingWithTests' :
                                                            notification.type.includes(feedback) ? 'feedback' :
                                                                notification.type.includes(justActivated) ? 'justActivated' :
                                                                    notification.type.includes(justConfirmed) ? 'justConfirmed' :
                                                                        notification.type.includes(activationExpires) ? 'activationExpires' : '', notification))

                                            toggleNotifications(false)
                                            dispatch(notificationMarkAsRead(notification.id))
                                        }}
                                        className={notification.read ? 'read' : ''}
                                    >
                                        <span>
                                            <img src={notification.type.includes(justRegistered) ? justStartedIcon :
                                                notification.type.includes(startingWithTopics) ? startingWithTopicsIcon :
                                                    notification.type.includes(watchedFirstVideoOfFirstTopic) ? watchedFirstVideoOfFirstTopicIcon :
                                                        notification.type.includes(startingWithTests) ? startingWithTestsIcon :
                                                            notification.type.includes(feedback) ? feedbackIcon :
                                                                notification.type.includes(justActivated) ? justActivatedIcon :
                                                                    notification.type.includes(justConfirmed) ? justConfirmedIcon :
                                                                        notification.type.includes(activationExpires) ? activationExpiresIcon : ''}
                                            />
                                        </span>
                                        <div className="right">
                                            <h3>
                                                {notification.title}
                                            </h3>
                                            <p>
                                                {notification.read ?
                                                    'отвори съобщението'
                                                    :
                                                    calcTime(notification.date_mdy).text
                                                }
                                            </p>
                                        </div>
                                    </li>
                                )}
                            </div>
                        </InfiniteScroll>
                    </ul>
                </div>
            </li >
        </ClickAwayListener>
    )
}

export default Notifications